<ng-container *ngIf="paginatedData.length > 0; else noData">
  <div class="table-container mt-4">
    <div class="card-container" *ngFor="let row of paginatedData"
      (click)="openPatientProfile.emit(row); $event.stopPropagation()"
      [ngClass]="{'blinker-row': row.notificationStatus && enumRole && enumRole.INSURER}">

      <div class="d-flex justify-content-between align-items-start w-100">

        <!-- Left content: avatar + name + details -->
        <div class="d-flex align-items-center gap-3">
          <div class="avatar-box-modern">
            <span class="initials">
              {{ row.firstName | initials : row.lastName}}
            </span>
          </div>

          <div class="d-flex flex-column">
            <h5 class="fw-500 mb-1">
              {{ row.firstName }} {{ row.lastName }}
              <span *ngIf="row.notificationStatus && enumRole && enumRole.INSURER" class="wifi-blinker ms-2"
                matTooltip="More info requested"></span>
            </h5>
            <div class="fs-11">
              {{ row.dateOfBirth | age }} , {{ row.gender.charAt(0) }}
            </div>
          </div>
        </div>

        <!-- Right aligned button -->
        <div *ngIf="row.status == 'OPEN'">
          <button class="primaryBtn align-items-center" style="padding: 5px 10px; font-size: 10px;"
            (click)="openRequestME.emit(row); $event.stopPropagation()">
            <span class="btnContent">Request ME</span>
          </button>
        </div>
        @if(enumRole==='DISTRIBUTOR'){
        <div *ngIf="row.status == 'DRAFTED'">
          <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
            (click)="openEditForm.emit(row); $event.stopPropagation()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path fill="#66AEE0" fill-rule="evenodd"
                d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
              <path fill="#66AEE0"
                d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                stroke-width="0.1" stroke="#66AEE0" />
            </svg>
          </span>
        </div>

        }
      </div>


      <div class="info-block p-3 rounded shadow-sm bg-white mt-2">
        <div class="info-item">
          <span class="gray-text fs-12">Phone:</span> <span class="info-text">{{ row.phone }}</span>
        </div>
        @if(enumRole==='DISTRIBUTOR'){
        <div class="info-item">
          <span class="gray-text fs-12">Email:</span> <span class="info-text">{{ row.email}}</span>
        </div>

        <div class="info-item">
          <span class="gray-text fs-12">Address:</span> <span class="info-text">{{ row.address}}</span>
        </div>
        }
        @if (enumRole != 'DISTRIBUTOR') {
        <div class="info-item">
          <span class="gray-text fs-12">Provider :</span> <span class="info-text">{{
            row?.serviceRequest?.provider?.name }}</span>
        </div>
        }
        @else {
        <div class="info-item">
          <span class="gray-text fs-12">Insurer :</span> <span class="info-text">{{
            row?.serviceRequest?.provider?.name }}</span>
        </div>
        }
        <div class="info-item">
          <span class="gray-text fs-12">Requested On:</span> <span class="info-text">{{ row?.serviceRequest?.createdon
            || row.createdon |
            date : 'dd/MM/yyyy HH:mm' }}</span>
        </div>

        @if (enumRole === 'DISTRIBUTOR') {
        <div class="info-item">
          <span class="gray-text fs-12">Turnaround:</span> <span class="info-text">{{ getTurnAroundTimes(row) }}</span>
        </div>
        }
        @else {
        <div class="info-item">
          <span class="gray-text fs-12">Turnaround:</span> <span class="info-text">{{ getTurnAroundTime(row) }}</span>
        </div>
        }
        <div class="info-footer d-flex justify-content-between align-items-center mt-3">
          <div class="gray-text fs-12">
            Updated On: {{ row?.serviceRequest?.lastupdatedon || row.lastupdatedon| date:'dd/MM/yyyy HH:mm' }}
          </div>
          <div class="status-container">
            <app-status-lables [entityType]="enumEntityType?.INSURER" [status]="row.status"></app-status-lables>
          </div>
          <!-- @if(enumRole==='DISTRIBUTOR'){
          <div class="status-container">
            <app-status-lables [entityType]="enumEntityType?.DISTRIBUTOR"
              [status]="row.serviceRequest ? row.serviceRequest?.status == 'SUBMITTED' ? 'RECEIVED' :row.serviceRequest?.status : 'OPEN'"></app-status-lables>
          </div>} -->
        </div>
      </div>
    </div>
  </div>
  <!-- @if(enumRole==='DISTRIBUTOR'){
  <div class="table-container mt-4">

  </div>} -->
  <div class="pagination-container">
      <span class="mt-1">Pages : </span>
      <button (click)="prevPage()" [disabled]="currentPage === 1" class="pagination-btn">‹</button>

      <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
        [ngClass]="{ 'active': currentPage === i + 1 }" class="pagination-btn">
        {{ i + 1 }}
      </button>

      <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="pagination-btn">›</button>
    </div>
</ng-container>
<ng-template #noData>
  <div class="custom-card">
    <app-no-data-found></app-no-data-found>
  </div>
</ng-template>
